<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
	defineProps<{
		size?: string;
		color?: string;
	}>(),
	{
		size: '24',
		color: 'text-default',
	}
);

const currentColor = computed<string>(() => {
	return props.color === 'inherit' ? 'inherit' : `var(--${props.color})`;
});
</script>

<template>
	<svg
		:style="{ color: currentColor }"
		class="loader"
		:width="size"
		:height="size"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 100 100"
		preserveAspectRatio="xMidYMid"
	>
		<rect x="17.5" y="23" width="15" height="54" fill="currentColor">
			<animate
				attributeName="y"
				repeatCount="indefinite"
				dur="1s"
				calcMode="spline"
				keyTimes="0;0.5;1"
				values="6.799999999999997;23;23"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.2s"
			></animate>
			<animate
				attributeName="height"
				repeatCount="indefinite"
				dur="1s"
				calcMode="spline"
				keyTimes="0;0.5;1"
				values="86.4;54;54"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.2s"
			></animate>
		</rect>
		<rect x="42.5" y="23" width="15" height="54" fill="currentColor">
			<animate
				attributeName="y"
				repeatCount="indefinite"
				dur="1s"
				calcMode="spline"
				keyTimes="0;0.5;1"
				values="10.849999999999994;23;23"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.1s"
			></animate>
			<animate
				attributeName="height"
				repeatCount="indefinite"
				dur="1s"
				calcMode="spline"
				keyTimes="0;0.5;1"
				values="78.30000000000001;54;54"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
				begin="-0.1s"
			></animate>
		</rect>
		<rect x="67.5" y="23" width="15" height="54" fill="currentColor">
			<animate
				attributeName="y"
				repeatCount="indefinite"
				dur="1s"
				calcMode="spline"
				keyTimes="0;0.5;1"
				values="10.849999999999994;23;23"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
			></animate>
			<animate
				attributeName="height"
				repeatCount="indefinite"
				dur="1s"
				calcMode="spline"
				keyTimes="0;0.5;1"
				values="78.30000000000001;54;54"
				keySplines="0 0.5 0.5 1;0 0.5 0.5 1"
			></animate>
		</rect>
	</svg>
</template>

<style lang="scss">
.loader {
	line-height: 1;
}
</style>
